(function($) {
    $.setQueryStringParam = function (uri, key, value) {
        const re = new RegExp("([?|&])" + key + "=.*?(&|$)", "i");
        const separator = uri.indexOf('?') !== -1 ? "&" : "?";
        if (uri.match(re)) {
            return uri.replace(re, '$1' + key + "=" + value + '$2');
        } else {
            return uri + separator + key + "=" + value;
        }
    };

    $.getQueryStringParam = function (uri, key) {
        const regExp = new RegExp('[\\?&]' + key + '=([^&#]*)', 'i');
        var decoded;

        try {
            decoded = decodeURIComponent(uri);
        } catch (err) {
            console.error(err);
            return '';
        }

        const val = regExp.exec(decoded);
        return val ? decodeURIComponent(val[1].replace(/\+/g, ' ')) : '';
    };

    $.removeQueryStringParam = function(uri, key) {
        const urlParts = uri.split('?');
        if (urlParts.length >= 2) {
            const prefix = encodeURIComponent(key) + '=';
            const pars = urlParts[1].split(/[&;]/g);

            // reverse iteration as may be destructive
            for (let i = pars.length; i-- > 0;) {
                if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                    pars.splice(i, 1);
                }
            }

            uri = urlParts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
            return uri;
        } else {
            return uri;
        }
    };

    $.getUrlParamsObj = function (uri) {
        const search = uri.substring(1);
        return search
            ? JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g, '":"') + '"}', function (key, value) { return key === '' ? value : decodeURIComponent(value) })
            : {};
    };
})(jQuery);